import "./App.css";
import { Nav } from "./components/sections/Nav";
import { Hero } from "./components/sections/Hero";
import { LogoMarquee } from "./components/sections/LogoMarquee";
import { PillarSection } from "./components/sections/PillarSection";
import { Differentiators } from "./components/sections/Differentiators";
import { Team } from "./components/sections/Team";
import { Testimonials } from "./components/sections/Testimonials";
import { Faq } from "./components/sections/Faq";
import { Contact } from "./components/sections/Contact";
import { Footer } from "./components/sections/Footer";
import { pillars } from "./data/siteContent";

function App() {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="app" data-testid="vartalab-page">
      <div className="orb orb-one" aria-hidden="true" />
      <div className="orb orb-two" aria-hidden="true" />
      <div className="grid-overlay" aria-hidden="true" />

      <Nav scrollToSection={scrollToSection} />
      <Hero scrollToSection={scrollToSection} />
      <LogoMarquee />

      {pillars.map((pillar) => (
        <PillarSection
          key={pillar.id}
          pillar={pillar}
          scrollToSection={scrollToSection}
        />
      ))}

      <Differentiators scrollToSection={scrollToSection} />
      <Team />
      <Testimonials />
      <Faq />
      <Contact />
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}

export default App;
